import { Menu, Transition } from '@headlessui/react'
import { useRouter } from 'next/router'
import { Fragment } from 'react'
import { useDispatch } from 'react-redux'
import { resetAthleteData } from 'src/store/athleteProfile'
import { resetUserData } from 'src/store/user'

export const NavUserMenu = () => {
    const dispatch = useDispatch()
    const router = useRouter()

    const logout = () => {
        dispatch(resetUserData())
        dispatch(resetAthleteData())
        localStorage.clear()
        void router.push('/')
    }

    return (
        <Menu as="div" className="inline-block text-left">
            <Menu.Button className="focus:outline-none">
                <i
                    aria-hidden
                    className="fas fa-cog text-gray-500 text-xl xs:text-3xl sm:text-4xl leading-none box-border cursor-pointer transition-all hover:text-gray-600"
                ></i>
            </Menu.Button>

            <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
            >
                <Menu.Items className="absolute z-50 right-2 w-56 mt-2 origin-top-right bg-gray-100 divide-y divide-gray-200 rounded-md shadow-2xl ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <div className="px-1 py-1 ">
                        <Menu.Item>
                            {({ active }) => (
                                <button
                                    onClick={() => void router.push('/profile')}
                                    className={`${
                                        active
                                            ? 'bg-yf-green text-white'
                                            : 'text-gray-700'
                                    } group flex rounded-md items-center w-full px-2 py-2 text-sm`}
                                >
                                    My Profile
                                    {active ? (
                                        <i className="fas fa-user w-5 h-5 ml-auto flex items-center justify-center text-base"></i>
                                    ) : (
                                        <i className="fas fa-user w-5 h-5 ml-auto flex items-center justify-center text-base"></i>
                                    )}
                                </button>
                            )}
                        </Menu.Item>
                    </div>
                    <div className="px-1 py-1">
                        <Menu.Item>
                            {({ active }) => (
                                <button
                                    onClick={() => logout()}
                                    className={`${
                                        active ? 'bg-yf-green text-white' : 'text-red-500'
                                    } group flex rounded-md items-center w-full px-2 py-2 text-sm`}
                                >
                                    Logout
                                    {active ? (
                                        <i className="far fa-sign-out w-5 h-5 ml-auto flex items-center justify-center text-base"></i>
                                    ) : (
                                        <i className="far fa-sign-out w-5 h-5 ml-auto flex items-center justify-center text-base"></i>
                                    )}
                                </button>
                            )}
                        </Menu.Item>
                    </div>
                </Menu.Items>
            </Transition>
        </Menu>
    )
}
